import { GET_STUDIO_SESSION_STATUSES } from "constants/studioSessions";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_STUDIO_SESSION_STATUSES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
